import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationIndexGroupPresenter } from "../../presenter/OrganisationIndexGroupPresenter";
import OrganisationIndexGroupTreeView from "../components/OrganisationIndexGroupTreeView";

export interface Props extends PageProps {}
export interface State extends IOrganisationIndexGroupPresenter {}

export default class OrganisationIndexGroupPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      createOrganisationIndexGroup,
      createOrganisationIndex,
      changeCreateGroupModalVisible,
      changeCreateItemModalVisible,
      indexTypeGroupId,
      indexTypeId,
      createGroupModalVisible,
      createItemModalVisible,
      organisationId,
      translate,
      categoryId,
      organisationTypeGroupId,
      searchableOrganisationIndexDataTree,
      searchDataTree,
      indexesNotInOrganisation,
      changeIndexesModalVisible,
      changeGroupsModalVisible,
      indexesModalVisible,
      groupsModalVisible,
      findConnectionCandidatesForIndex,
      findConnectionCandidatesForGroup,
      toggleConnected,
      toggleGroupConnected,
      connectIndexes,
      connectGroups,
      selectOrganisationIndex,
      clickedIndex,
      clickedGroup,
      hierarchyList,
      connectedIndexes,
      connectedIndexGroups,
      indexInfoVisible,
      groupInfoVisible,
      store,
      groupModelsCandidates,
      updateOrganisationIndex,
      changeUpdateIndexModalVisible,
      updateIndexModalVisible,
      selectOrganisationIndexGroup,
      updateIndexGroupModalVisible,
      changeUpdateIndexGroupModalVisible,
      updateOrganisationIndexGroup,
      searchFunction,
      searchGroupFunction,
      toggleFilterByParentName,
      toggleGroupFilterByParentName,
      canEdit,
      removeOrganisationIndex,
      getCaseLawDocumentsForIndex,
      caseLawDocuments,
      caseLawDocsModalVisible,
      deleteWarningModalVisible,
      changeCaseLawDocsModalVisible,
      changeDeleteWarningModalVisible,
      showCaseLawDocumentDetails,
      getSwitchGroupCandidates,
      switchCandidates,
      toggleSwitchGroup,
      selectedSwitchCandidate,
      changeSwitchGroupVisible,
      switchGroupVisible,
      switchGroupForIndex,
      searchSwitchGroupFunction,
      changeDeleteGroupVisible,
      changeDeleteGroupWarningVisible,
      checkCanGroupBeRemoved,
      deleteGroupModalVisible,
      deleteGroupWarningVisible,
      removeOrganisationIndexGroup,
      canSelectedIndexBeNonHarmonized,
      connectionCandidatesByCategory,
      findConnectionCandidatesByCategory,
      toggleConnectedByCategory,
      connectedIndexesByCategory
    } = this.state;
    return (
      <Page {...this.props} className={"content-wrapper"}>
        <Spin spinning={this.state.loaders.organisationIndexGroupsLoader}>
          <div className="card-container mt-0">
            <OrganisationIndexGroupTreeView
              searchDataTree={searchDataTree}
              organisationIndexDataTree={searchableOrganisationIndexDataTree}
              createOrganisationIndexGroup={createOrganisationIndexGroup}
              createOrganisationIndex={createOrganisationIndex}
              changeCreateGroupModalVisible={changeCreateGroupModalVisible}
              changeCreateItemModalVisible={changeCreateItemModalVisible}
              indexTypeGroupId={indexTypeGroupId}
              indexTypeId={indexTypeId}
              createGroupModalVisible={createGroupModalVisible}
              createItemModalVisible={createItemModalVisible}
              organisationId={organisationId}
              translate={translate}
              categoryId={categoryId}
              organisationTypeGroupId={organisationTypeGroupId}
              loader={this.state.loaders.organisationIndexGroupsLoader}
              indexesNotInOrganisation={indexesNotInOrganisation}
              changeIndexesModalVisible={changeIndexesModalVisible}
              changeGroupsModalVisible={changeGroupsModalVisible}
              changeUpdateIndexGroupModalVisible={
                changeUpdateIndexGroupModalVisible
              }
              indexesModalVisible={indexesModalVisible}
              groupsModalVisible={groupsModalVisible}
              findConnectionCandidatesForIndex={
                findConnectionCandidatesForIndex
              }
              findConnectionCandidatesForGroup={
                findConnectionCandidatesForGroup
              }
              toggleConnected={toggleConnected}
              toggleGroupConnected={toggleGroupConnected}
              connectIndexes={connectIndexes}
              selectOrganisationIndex={selectOrganisationIndex}
              clickedIndex={clickedIndex}
              clickedGroup={clickedGroup}
              hierarchyList={hierarchyList}
              connectedIndexes={connectedIndexes}
              connectedIndexGroups={connectedIndexGroups}
              connectGroups={connectGroups}
              indexInfoVisible={indexInfoVisible}
              groupInfoVisible={groupInfoVisible}
              groupModelsCandidates={groupModelsCandidates}
              store={store}
              updateOrganisationIndex={updateOrganisationIndex}
              changeUpdateIndexModalVisible={changeUpdateIndexModalVisible}
              updateIndexModalVisible={updateIndexModalVisible}
              updateIndexGroupModalVisible={updateIndexGroupModalVisible}
              selectOrganisationIndexGroup={selectOrganisationIndexGroup}
              updateOrganisationIndexGroup={updateOrganisationIndexGroup}
              searchFunction={searchFunction}
              searchGroupFunction={searchGroupFunction}
              toggleFilterByParentName={toggleFilterByParentName}
              toggleGroupFilterByParentName={toggleGroupFilterByParentName}
              canEdit={canEdit}
              removeOrganisationIndex={removeOrganisationIndex}
              getCaseLawDocumentsForIndex={getCaseLawDocumentsForIndex}
              caseLawDocuments={caseLawDocuments}
              caseLawDocsModalVisible={caseLawDocsModalVisible}
              deleteWarningModalVisible={deleteWarningModalVisible}
              changeCaseLawDocsModalVisible={changeCaseLawDocsModalVisible}
              changeDeleteWarningModalVisible={changeDeleteWarningModalVisible}
              showCaseLawDocumentDetails={showCaseLawDocumentDetails}
              getSwitchGroupCandidates={getSwitchGroupCandidates}
              switchCandidates={switchCandidates}
              toggleSwitchGroup={toggleSwitchGroup}
              selectedSwitchCandidate={selectedSwitchCandidate}
              changeSwitchGroupVisible={changeSwitchGroupVisible}
              switchGroupVisible={switchGroupVisible}
              switchGroupForIndex={switchGroupForIndex}
              searchSwitchGroupFunction={searchSwitchGroupFunction}
              changeDeleteGroupVisible={changeDeleteGroupVisible}
              changeDeleteGroupWarningVisible={changeDeleteGroupWarningVisible}
              checkCanGroupBeRemoved={checkCanGroupBeRemoved}
              deleteGroupModalVisible={deleteGroupModalVisible}
              deleteGroupWarningVisible={deleteGroupWarningVisible}
              removeOrganisationIndexGroup={removeOrganisationIndexGroup}
              canSelectedIndexBeNonHarmonized={canSelectedIndexBeNonHarmonized}
              connectionCandidatesByCategory={connectionCandidatesByCategory}
              findConnectionCandidatesByCategory={
                findConnectionCandidatesByCategory
              }
              toggleConnectedByCategory={toggleConnectedByCategory}
              connectedIndexesByCategory={connectedIndexesByCategory}
            />
          </div>
        </Spin>
      </Page>
    );
  }
}
